import {
  Component,
  ViewChild,
  ElementRef,
  OnInit,
  TemplateRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { CommonService } from "../common.service";
import { DomSanitizer } from "@angular/platform-browser";
import { TokenLogService } from "../_services/tokenLogService";
import { XrmService } from "../_services/xrmService";
import { XrmEntry } from "../_models/xrmEntry";
import { ManagementCompany } from "../_models/managementCompany";
import { InsertCompanyRecord } from "../_models/insertCompanyRecord";
import { ClientSignUpCompany } from "../_models/clientSignUpCompany";
import { ClientInfo } from "../_models/clientInfo";
import { ValidateTokenModel } from "../_models/validateTokenModel";
import { LogEntry } from "../_models/logEntry";
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-contract",
  templateUrl: "./contract.component.html",
  styleUrls: ["./contract.component.css"],
})
export class ContractComponent implements OnInit {
  @ViewChild("iframe", { static: true }) iframe: ElementRef;
  @ViewChild("content", { static: true }) private contentRef: NgbModalRef;
  public defaultCheck1: boolean = false;
  public defaultCheck1Error: any;
  public error: string;
  public token: any =
    "3AAABLblqZhB7chSSVUtgXIYKpiL7DaiL3jsD8FZbR0AhC4S4eoCSzLs7_VUnKEAEdztDxX2jcsfj1X3nKzPyAH-kicAS5TmE";
  public url: string = "https://api.in1.echosign.com/api/rest/v6/agreements";
  public iframeURL: any;
  public registrationDetails: any;
  public adobeSignIFrame: ElementRef;
  public modalOpened = false;

  companyName: string;
  clientId: string;
  clientSecret: string;
  email: string;
  phone: string;
  contactName: string;
  clientSignUpCompany: ClientSignUpCompany;
  xrmEntry: XrmEntry;

  constructor(
    private router: Router,
    public authService: CommonService,
    public sanitizer: DomSanitizer,
    private readonly tokenLogService: TokenLogService,
    private readonly xrmService: XrmService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    const sessionStart = localStorage.getItem("sessionStart");
    if (sessionStart) {
      const savedDate = Date.parse(sessionStart);
      let diffInMs = Math.abs(Date.now() - savedDate);
      setTimeout(() => {
        const companyName = localStorage.getItem("companyName");
        const contactName = localStorage.getItem("contactName");
        const email = localStorage.getItem("email");
        const phone = localStorage.getItem("phone");
        const logEntry: LogEntry = {
          pageNumber: 4,
          companyName: companyName,
          vendorClientUniqueId: localStorage.getItem("vendorClientUniqueId"),
          message:
            "Session time out - redirected to timeout page after 60 minutes",
          exception: null,
          clientId: "",
          clientSecret: "",
          email: email,
          phone: phone,
          contactName: contactName,
          sessionId: localStorage.getItem("sessionId"),
          password: null,
          companyLegalName: null,
          numberOfProperties: 0,
          numberOfUnits: 0,
          street1: null,
          city: null,
          state: null,
          zipCode: null,
          country: null,
          settlementAuth: null,
          clientVendorId: 1,
        };
        this.tokenLogService
          .logEntry(logEntry)
          .toPromise()
          .then(
            () => {
              console.log("Token entry set correctly");
            },
            (error) => {
              console.log(
                "An error has occurred while creating log entry: ",
                error
              );
            }
          );
        this.router.navigateByUrl("timeout");
      }, 60 * 60 * 1000 - diffInMs);
    }
    this.clientSignUpCompany = JSON.parse(
      localStorage.getItem("clientSignUpCompany")
    );
    this.xrmEntry = JSON.parse(localStorage.getItem("xrmEntry"));
    // logging third page
    this.companyName = localStorage.getItem("companyName");
    this.clientId = localStorage.getItem("clientId");
    this.clientSecret = localStorage.getItem("clientSecret");
    this.email = localStorage.getItem("email");
    this.phone = localStorage.getItem("phone");
    this.contactName = localStorage.getItem("contactName");
    const logEntry: LogEntry = {
      pageNumber: 4,
      companyName: this.companyName,
      vendorClientUniqueId: localStorage.getItem("vendorClientUniqueId"),
      message: "Contract page reached",
      exception: null,
      clientId: this.clientId,
      clientSecret: this.clientSecret,
      email: this.email,
      phone: this.phone,
      contactName: this.contactName,
      sessionId: localStorage.getItem("sessionId"),
      password: localStorage.getItem("password"),
      companyLegalName: this.clientSignUpCompany.companyLegalName,
      numberOfProperties: this.clientSignUpCompany.numberOfProperties,
      numberOfUnits: this.clientSignUpCompany.numberOfUnits,
      street1: this.clientSignUpCompany.physicalAddress.street1,
      city: this.clientSignUpCompany.physicalAddress.city,
      state: this.clientSignUpCompany.physicalAddress.state,
      zipCode: this.clientSignUpCompany.physicalAddress.zipCode,
      country: this.clientSignUpCompany.physicalAddress.country,
      settlementAuth: this.xrmEntry.settlementAuth,
      clientVendorId: 1,
    };
    this.tokenLogService
      .logEntry(logEntry)
      .toPromise()
      .then(
        () => {
          console.log("Token entry set correctly");
        },
        (error) => {
          console.log(
            "An error has occurred while creating log entry: ",
            error
          );
        }
      );
    this.registrationDetails = JSON.parse(
      localStorage.getItem("registrationDetails")
    );
    const Client =
      this.registrationDetails.registrationFormData.companyDetailsObj.LegalName;
    const cAdd1 =
      this.registrationDetails.registrationFormData.companyDetailsObj
        .PhysicalAddress.Street1;
    const cCity =
      this.registrationDetails.registrationFormData.companyDetailsObj
        .PhysicalAddress.City;
    const cState =
      this.registrationDetails.registrationFormData.companyDetailsObj
        .PhysicalAddress.State;
    const cZipCode =
      this.registrationDetails.registrationFormData.companyDetailsObj
        .PhysicalAddress.ZipCode;
    const contact = JSON.parse(localStorage.getItem("contact"));
    const contactFullName = contact.firstName + " " + contact.lastName;

    let fullUrl =
      "https://residentinterface.na1.echosign.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhAr8enj894akf2ISJmIYpJSRLml6d__O7v8i5HVHDi5V8TZ_lNJi0Jn_HFHBDiMovY*";
    fullUrl += `#Company=${Client}&Address=${cAdd1}&City=${cCity}&StateAbbrev=${cState}&Zipcode=${cZipCode}&Name=${contactFullName}`;
    fullUrl += `&Phone=${contact.workPhone}&PhoneExt=&Email=${contact.email}&Settlement=${this.registrationDetails.registrationFormData.companyDetailsObj.SettlementAuth}`;
    this.iframeURL = this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
  }

  createCompany() {
    // adding log entry when client signed the contract
    const logEntry: LogEntry = {
      pageNumber: 4,
      companyName: this.companyName,
      vendorClientUniqueId: localStorage.getItem("vendorClientUniqueId"),
      message:
        "Client signed the contract, will call Buildium for token redemption next",
      exception: null,
      clientId: this.clientId,
      clientSecret: this.clientSecret,
      email: this.email,
      phone: this.phone,
      contactName: this.contactName,
      sessionId: localStorage.getItem("sessionId"),
      password: localStorage.getItem("password"),
      companyLegalName: this.clientSignUpCompany.companyLegalName,
      numberOfProperties: this.clientSignUpCompany.numberOfProperties,
      numberOfUnits: this.clientSignUpCompany.numberOfUnits,
      street1: this.clientSignUpCompany.physicalAddress.street1,
      city: this.clientSignUpCompany.physicalAddress.city,
      state: this.clientSignUpCompany.physicalAddress.state,
      zipCode: this.clientSignUpCompany.physicalAddress.zipCode,
      country: this.clientSignUpCompany.physicalAddress.country,
      settlementAuth: this.xrmEntry.settlementAuth,
      clientVendorId: 1,
    };
    this.tokenLogService
      .logEntry(logEntry)
      .toPromise()
      .then(
        () => {
          console.log("Token entry set correctly");
        },
        (error) => {
          console.log(
            "An error has occurred while creating log entry: ",
            error
          );
        }
      );

    this.modalService.open(this.contentRef);
    // redeeming token
    const token = localStorage.getItem("token");
    let clientId = "";
    let clientSecret = "";
    const contact = JSON.parse(localStorage.getItem("contact"));
    const contactFullName = contact.firstName + " " + contact.lastName;
    let companyName = localStorage.getItem("companyName");
    const validateToken: ValidateTokenModel = {
      token: token,
      companyName: companyName,
      contactName: contactFullName,
      email: contact.email,
      phone: contact.workPhone,
      exception: null,
      sessionId: localStorage.getItem("sessionId"),
    };
    this.tokenLogService
      .postToken(validateToken)
      .toPromise()
      .then(
        (result: ClientInfo) => {
          localStorage.setItem("clientId", result.clientId);
          localStorage.setItem("clientSecret", result.clientSecret);
          clientId = result.clientId;
          clientSecret = result.clientSecret;
          this.createServiceRecord(clientId, clientSecret);
        },
        (error) => {
          console.log(
            "An error has occurred while redeeming Buildium token: ",
            error
          );
          const logEntry: LogEntry = {
            pageNumber: 4,
            companyName: this.companyName,
            vendorClientUniqueId: localStorage.getItem("vendorClientUniqueId"),
            message: "An error has occurred while redeeming Buildium token.",
            exception: JSON.stringify(error),
            clientId: this.clientId,
            clientSecret: this.clientSecret,
            email: this.email,
            phone: this.phone,
            contactName: this.contactName,
            sessionId: localStorage.getItem("sessionId"),
            password: localStorage.getItem("password"),
            companyLegalName: this.clientSignUpCompany.companyLegalName,
            numberOfProperties: this.clientSignUpCompany.numberOfProperties,
            numberOfUnits: this.clientSignUpCompany.numberOfUnits,
            street1: this.clientSignUpCompany.physicalAddress.street1,
            city: this.clientSignUpCompany.physicalAddress.city,
            state: this.clientSignUpCompany.physicalAddress.state,
            zipCode: this.clientSignUpCompany.physicalAddress.zipCode,
            country: this.clientSignUpCompany.physicalAddress.country,
            settlementAuth: this.xrmEntry.settlementAuth,
            clientVendorId: 1,
          };
          this.tokenLogService
            .logEntry(logEntry)
            .toPromise()
            .then(
              () => {
                console.log("Token entry set correctly");
              },
              (error) => {
                console.log(
                  "An error has occurred while creating log entry: ",
                  error
                );
              }
            );
        }
      );
  }

  createServiceRecord(clientId: string, clientSecret: string) {
    const contact = JSON.parse(localStorage.getItem("contact"));
    const password = localStorage.getItem("password");
    const xrmEntry: XrmEntry = JSON.parse(localStorage.getItem("xrmEntry"));
    const clientSignUpCompany: ClientSignUpCompany = JSON.parse(
      localStorage.getItem("clientSignUpCompany")
    );
    clientSignUpCompany.clientID = clientId;
    clientSignUpCompany.clientSecret = clientSecret;
    const managementCompany: ManagementCompany = {
      rpUser: "BLD_" + clientSignUpCompany.vendorClientUniqueId,
      encryptionKey: password,
      highestLevel: null,
      managementCo: xrmEntry.name,
    };

    const insertCompanyRecord: InsertCompanyRecord = {
      clientSignUpCompany: clientSignUpCompany,
      companyFromTemplateInsert: {
        company: xrmEntry,
        accountNumber: "",
        password: password,
        prefix: "G.",
        parentAccount: null,
      },
      contact: contact,
      managementCompany: managementCompany,
    };

    this.xrmService
      .insertCompanyRecord(insertCompanyRecord)
      .toPromise()
      .then(
        (result: any) => {
          localStorage.setItem("clientNumber", result.accountNumber);
          this.modalService.dismissAll();
          this.router.navigate(["/welcome"]);
        },
        (error) => {
          console.log(
            "An error occurred while creating management company:",
            error
          );
          const logEntry: LogEntry = {
            pageNumber: 4,
            companyName: this.companyName,
            vendorClientUniqueId: localStorage.getItem("vendorClientUniqueId"),
            message: "An error has occurred while creating management company.",
            exception: JSON.stringify(error),
            clientId: this.clientId,
            clientSecret: this.clientSecret,
            email: this.email,
            phone: this.phone,
            contactName: this.contactName,
            sessionId: localStorage.getItem("sessionId"),
            password: localStorage.getItem("password"),
            companyLegalName: this.clientSignUpCompany.companyLegalName,
            numberOfProperties: this.clientSignUpCompany.numberOfProperties,
            numberOfUnits: this.clientSignUpCompany.numberOfUnits,
            street1: this.clientSignUpCompany.physicalAddress.street1,
            city: this.clientSignUpCompany.physicalAddress.city,
            state: this.clientSignUpCompany.physicalAddress.state,
            zipCode: this.clientSignUpCompany.physicalAddress.zipCode,
            country: this.clientSignUpCompany.physicalAddress.country,
            settlementAuth: this.xrmEntry.settlementAuth,
            clientVendorId: 1,
          };
          this.tokenLogService
            .logEntry(logEntry)
            .toPromise()
            .then(
              () => {
                console.log("Token entry set correctly");
              },
              (error) => {
                console.log(
                  "An error has occurred while creating log entry: ",
                  error
                );
              }
            );
        }
      );
  }
}
